var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalOutdoorT = function SvgDAhuSignalOutdoorT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "140,283.1 138,283.1 138,270 178,270 178,272 140,272",
    fill: "#1C9D5B"
  })));
};
export default SvgDAhuSignalOutdoorT;